var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide html-frame"},[(_vm.data.html_url)?_c('iframe',{staticClass:"frame",attrs:{"src":_vm.data.html_url,"sandbox":"allow-scripts allow-same-origin","referrerpolicy":"no-referrer","loading":"eager"}}):_c('div',{staticClass:"placeholder"},[_vm._v(" No HTML file attached — drop one in the slide editor. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }